import { render, staticRenderFns } from "./CreatedAccount.vue?vue&type=template&id=1a5a62f8&scoped=true&"
import script from "./CreatedAccount.vue?vue&type=script&lang=js&"
export * from "./CreatedAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreatedAccount.vue?vue&type=style&index=0&id=1a5a62f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a62f8",
  null
  
)

export default component.exports